import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { debounce } from '~js/utils/utils';

export class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector(s.selectors$17.inputSearch);
    this.form = this.querySelector(s.selectors$17.form);
    this.popdownBody = this.closest(s.selectors$17.popdownBody);
    this.popularSearches = this.popdownBody?.querySelector(s.selectors$17.popularSearches);
    this.predictiveSearchResults = this.querySelector(s.selectors$17.predictiveSearchResults);
    this.predictiveSearch = this.matches(s.selectors$17.predictiveSearch);
    this.searchForm = this.matches(s.selectors$17.searchForm);
    this.selectedElement = null;
    this.activeElement = null;
    this.searchTerm = '';
    this.currentSearchTerm = '';
    this.isSearchPage = document.body.classList.contains(c.classes$X.templateSearch);

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    if (this.isSearchPage) {
      this.mainInputType = document.querySelector(`${s.selectors$17.mainInputSearch} ${s.selectors$17.inputType}`);
      this.inputType = this.querySelector(s.selectors$17.inputType);
      this.inputType.value = this.mainInputType.value;
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onFocus() {
    this.currentSearchTerm = this.getQuery();
  }

  onChange() {
    this.classList.toggle(c.classes$X.isSearched, !this.isFormCleared());
    this.searchTerm = this.getQuery();
  }

  isFormCleared() {
    return this.input.value.length === 0;
  }

  submit() {
    this.form.submit();
  }

  reset() {
    this.input.val = '';
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector(s.selectors$17.selectedLink)) event.preventDefault();
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  onKeyup(event) {
    if (!this.getQuery().length && this.predictiveSearch) {
      this.close(true);
    }
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  switchOption(direction) {
    const moveUp = direction === 'up';
    const predictiveSearchOpened = this.classList.contains(c.classes$X.isSearched) && this.predictiveSearchResults;

    const visibleElementsContainer = predictiveSearchOpened ? this.predictiveSearchResults : this.popularSearches;

    if (!visibleElementsContainer) return;
    this.selectedElement = visibleElementsContainer.querySelector(s.selectors$17.ariaSelected);

    // Filter out hidden elements
    const allVisibleElements = Array.from(
      visibleElementsContainer.querySelectorAll(s.selectors$17.allVisibleElements)
    ).filter((element) => element.offsetParent !== null);

    let activeElementIndex = 0;

    if (moveUp && !this.selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === this.selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    if (!moveUp && this.selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    this.activeElement = allVisibleElements[activeElementIndex];
    this.handleFocusableDescendants();
  }

  selectOption() {
    const selectedOption = this.querySelector(s.selectors$17.selectedOption);

    if (selectedOption) selectedOption.click();
  }

  handleFocusableDescendants(reset = false) {
    const selected = this.selectedElement ? this.selectedElement : this.querySelector(s.selectors$17.ariaSelected);
    if (selected) selected.setAttribute('aria-selected', false);

    if (!this.activeElement || reset) {
      this.selectedElement = null;
      this.activeElement?.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-expanded', false);
      this.input.setAttribute('aria-activedescendant', '');
      return;
    }

    this.activeElement.setAttribute('aria-selected', true);
    this.input.setAttribute('aria-activedescendant', this.activeElement.id);
  }
}